import { Fragment, useEffect, useState } from "react";
import DashboardContainer from "../Common/Components/DashboardContainer";
import NetworkDiagramWidget from "./NetworkDiagramWidget";
import { useParams, useSearchParams } from "react-router-dom";

const Events = () => {
  const positionData = [{ col: 1, colSpan: 6, rowSpan: 12 }];
  const [customerId, updateCustomerId] = useState(null);
  const [urlParamsDone, updateUrlParamDone] = useState(false);

  const [urlParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (!urlParamsDone) {
      updateUrlParamDone(true);
      if (urlParams.get("customerId") != null) {
        updateCustomerId(urlParams.get("customerId"));
      }
    }
  }, [urlParams]);

  const sidebarItems: { title: string; item: any; expanded: boolean }[] = [];
  const defaultWidgets = [
    <NetworkDiagramWidget
      id="ndw"
      header="Network Diagram"
      thumb={false}
    />,
  ];
  if (customerId == null) {
    return <div>No customer ID found.</div>;
  }
  return (
    <Fragment>
      <DashboardContainer
        positionData={positionData}
        sidebarItems={sidebarItems}
        defaultWidgets={defaultWidgets}
        noSidebar={true}
      />
    </Fragment>
  );
};
export default Events;
